// extracted by mini-css-extract-plugin
module.exports = {"badge":"SocialBadge__badge___3VVFD","icon":"SocialBadge__icon___U6F-S"};